import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, showNotification, refreshView as refreshViewAction } from 'react-admin';

import request from '../../../../network/request';
import resourceConfig from './config';

class UpdateKmButton extends Component {
    state = {
      executing: false
    }
    handleClick = async() => {
        const { showNotification, record, refreshView } = this.props;

        this.setState({
          executing: true
        });
        let data = {
          mrkId: record.id
        }
        let response = null;
        try {
          response = await request({
            apiService: 'shoes',
            path: '/admin/mrk/func/update_km',
            urlParams: data,
            method: 'POST',
          })
        } catch (e) {
          console.error(e);
        }
        if (response === null || !response.ok) {
          showNotification(`resources.${resourceConfig.name}.updateKM.errorMessage`, 'error');
        } else {
          showNotification(`resources.${resourceConfig.name}.updateKM.successMessage`, 'success');
        }
        
        this.setState({
          executing: false
        }, refreshView);
    };
    

    render() {
        return (
            <Button label={`resources.${resourceConfig.name}.updateKM.action`} disabled={this.state.executing} onClick={this.handleClick} />
        );
    }
}

export default connect(undefined, { 
  showNotification, 
  refreshView: refreshViewAction 
})(UpdateKmButton);